module.exports = __webpack_public_path__ + "static/media/helix.69fd34c5.png";